import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { type Unit, unitImage } from './unit'
import type { RenderCachedImage } from '../image/WithCachedImage'
import type { Identifiable } from '../../../shared/lib/typeHelpers.no-deps'
import type { TSimpleUnit } from '../../../shared/domain/units/types.no-deps'

interface Props {
    deps: CommonDeps
    renderCachedImage: RenderCachedImage
    unit: Unit | Identifiable<TSimpleUnit>
}

export class UnitImage extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private tryRender = () => {
        const url = unitImage(this.props.unit)
        return (
            <div className="AppCore__unit__UnitImage">
                {this.props.renderCachedImage(url, null, this.props.deps.getImage('missing-unit'))}
            </div>
        )
    }
}
